import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  AppBar,
  TablePagination,
  Toolbar,
  IconButton,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Autocomplete
} from '@mui/material'
import {
  Restaurant,
  ArrowBack,
  Save,
  Search,
  Person
} from '@mui/icons-material'

import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import PropTypes from 'prop-types';

import { format, parseISO } from 'date-fns';

import Collapse from '@mui/material/Collapse';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useAuth } from '../../contexts/AuthContext'
import api from '../../utils/axios'
import Form from './../../components/Form.css'

const Formalimento = () => {
  const navigate = useNavigate()
  const { user, updateUser } = useAuth()
  console.log(user);

  const [rows, setRows] = useState([]);
  const [generosalimenticios, setGenerosalimenticios] = useState([]);
  const [selecionados, setSelecionados] = useState([]);
  const [alimentossalvos, setAlimentossalvos] = useState([]);

  const [itemEdit, setItemEdit] = useState(null);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
      nome: itemEdit?.nome || '',
      medida: itemEdit?.medida || ''      
    }
  })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  //   const { row } = props;
  const [open, setOpen] = React.useState(false);

  const [mode, setMode] = useState('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (mode === "edit" && itemEdit) {
      reset(itemEdit); // <-- Aqui acontece a mágica
    } else if (mode === "create" || mode === "Busca" || !itemEdit) {
      console.log('resettttttt');
      const defaultValues = {
        nome: '',
        medida: ''        
      };
      reset(defaultValues);
      setRows([]);
    }
  }, [itemEdit, reset, mode]);

  const handleEdit = async (item) => {
    console.log(item);
    setMode('edit');
    setItemEdit(item);
    reset(item);


    try {
      const response = await api.put('/alimentos/list.php', {
        id: item.id,       
      })

      console.log(response.data);

      if (response.data.success) {
        // const updatedUser = { ...user, ...data }
        // console.log(updateUser);
        setGenerosalimenticios(response.data.alimentos);
        setSelecionados(response.data.alimentos);
        // updateUser(updatedUser)
        // setSuccess('Dados atualizados com sucesso!')
        // setTimeout(() => {
        //   navigate('/produtor')
        // }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }





    // if (eventos.length && eventosSalvos.length) {
    //   const selecionados = eventos.filter(e =>
    //     eventosSalvos.includes(e.id)
    //   );
    //   setEventosSelecionados(selecionados);
    // }

  }

  const onSubmit = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)


    console.log(data);
    console.log(mode);


    if (!data.id) {
      try {
        const response = await api.put('/alimentos/save.php', {
          // id: data.id,
          nome: data.nome,
          medida: data.medida  

        })

        if (response.data.success) {
          // const updatedUser = { ...user, ...data }
          // updateUser(updatedUser)
          setSuccess('Dados atualizados com sucesso!')
          // setTimeout(() => {
          //   navigate('/produtor')
          // }, 1500)
        } else {
          setError(response.data.message || 'Erro ao atualizar dados')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao atualizar dados')
      } finally {
        setLoading(false)
      }
    } else {

      setMode('create');


      try {
        const response = await api.put('/alimentos/update.php', {
          id: data.id,
          nome: data.nome,
          medida: data.medida
        })

        console.log(response);

        if (response.data.success) {
          // const updatedUser = { ...user, ...data }
          // updateUser(updatedUser)
          setSuccess('Dados atualizados com sucesso!')
          // setTimeout(() => {
          //   navigate('/produtor')
          // }, 1500)
        } else {
          setError(response.data.message || 'Erro ao atualizar dados')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao atualizar dados')
      } finally {
        setLoading(false)
      }
    }
  }

  const onSubmitBusca = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)
    setMode('');
    setPage(0);

    console.log(data);


    try {
      const response = await api.put('/alimentos/list.php', {
        id: user.id,
        nome: data.nome,
        medida: data.medida
      })

      console.log(response.data.alimentos);

      if (response.data.success) {
        // const updatedUser = { ...user, ...data }
        // console.log(updateUser);
        setRows(response.data.alimentos)
        // updateUser(updatedUser)
        // setSuccess('Dados atualizados com sucesso!')
        // setTimeout(() => {
        //   navigate('/produtor')
        // }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }
  }


  const loadAlimentos = async () => {
    setLoading(true);
    try {
      const response = await api.put('/alimentos/list.php', {
        // id: user.id,
        // nome: data.nome,
        // cpf: data.cpf,
        // caf: data.caf,
        // data_inscricao_caf: data.data_inscricao_caf
      })

      console.log(response.data.alimentos);

      if (response.data.success) {
        // const updatedUser = { ...user, ...data }
        console.log(response.data.alimentos);
        setGenerosalimenticios(response.data.alimentos)
        // updateUser(updatedUser)
        // setSuccess('Dados atualizados com sucesso!')
        // setTimeout(() => {
        //   navigate('/produtor')
        // }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => { loadAlimentos(); }, []);

  function Row(props) {
    console.log(props);
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow onClick={() => handleEdit(row)} sx={{ '& > *': { borderBottom: 'unset' }, cursor: "pointer" }}>
          {/* <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell> */}
          <TableCell component="th" scope="row">
            {row.nome}
          </TableCell>
          <TableCell align="right">{row.medida}</TableCell>          
        </TableRow>
        <TableRow>
          {/* <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Outros dados
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Data de Nascimento</TableCell>
                      <TableCell>Cônjuge</TableCell>
                      <TableCell align="right">Telefone</TableCell>
                      <TableCell align="right">Sítio/propriedade</TableCell>
                      <TableCell align="right">Localidade</TableCell>
                      <TableCell align="right">Geo referência</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {!row.dtnascimento || row.dtnascimento === '0000-00-00' ? '' : format(parseISO(row.dtnascimento), 'dd/MM/yyyy')}
                      </TableCell>
                      <TableCell>{row.nmconjuge}</TableCell>
                      <TableCell align="right">{row.telefone}</TableCell>
                      <TableCell align="right">
                        {row.sitiopropriedade}
                      </TableCell>
                      <TableCell align="right">
                        {row.localidadereferencia}
                      </TableCell>
                      <TableCell align="right">
                        <a
                          href={geoStringToGoogleMapsLink(row.pontogeoreferencia)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {row.pontogeoreferencia}
                        </a>
                        
                      </TableCell>
                    </TableRow>
                    
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell> */}
        </TableRow>
      </React.Fragment>
    );
  }

  const Cadastro = () => {
    return (
      <Container sx={{ py: 3 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Person sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Gêneros Alimentícios
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}



          <form className='admin-form' onSubmit={handleSubmit(onSubmit)}>
            {/* <div style={{display:'flex', flexDirection:'row'}}> */}
            <Grid container spacing={3}>
              {/* <div className="form-row col"> */}
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Nome do Alimento"
                  margin="normal"
                  {...register('nome', {
                    // required: 'Nome é obrigatório',
                    minLength: {
                      value: 3,
                      message: 'Nome deve ter no mínimo 3 caracteres'
                    }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              
              <Grid item xs={12} md={4}>

                <TextField
                  fullWidth
                  // className='form-control'
                  label="Medida"
                  margin="normal"
                  {...register('medida', {
                    // required: 'CAF é obrigatório'
                  })}
                  error={!!errors.medida}
                  helperText={errors.medida?.message}
                />
              </Grid>
              

              <Grid item xs={12} md={12}>
                {console.log(mode)}

                {(mode != 'create' && mode != 'edit') ? (<Button
                  //   type="submit"
                  //   fullWidth
                  onClick={() => setMode('create')}
                  variant="contained"
                  size="large"
                  sx={{ mt: 3 }}
                  startIcon={<Save />}
                  disabled={loading}
                >
                  {'Novo'}
                  {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                </Button>) :

                  (<Button
                    type="submit"
                    //   fullWidth
                    // onClick={() => setMode('create')}
                    variant="contained"
                    size="large"
                    sx={{ mt: 3 }}
                    startIcon={<Save />}
                    disabled={loading}
                  >
                    {'Salvar'}
                    {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                  </Button>)
                }

                
                <Button
                  type={"button"}
                  //   fullWidth
                  variant="contained"
                  size="large"
                  onClick={() => setMode('Busca')}
                  sx={{ mt: 3, marginLeft: 2, backgroundColor: '#7469ea' }}
                  startIcon={mode == 'create' ? <KeyboardReturnIcon /> : <Search />}
                  disabled={loading}
                >
                  {'Voltar'}
                  {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                </Button>
              </Grid>
            </Grid>
          </form>

          {rows && mode !== 'create' && mode !== 'edit' && <React.Fragment>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell>Nome</TableCell>
                    <TableCell align="right">Medida</TableCell>                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <Row key={row.name} row={row} />
                    ))}
                </TableBody>
              
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={rows.length}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 25]}
              labelRowsPerPage="Linhas por página"
            />

          </React.Fragment>}

        
        </Paper>
      </Container>
    )
  }


  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/produtor')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Person sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Meu Perfil
          </Typography>
        </Toolbar>
      </AppBar>

      {mode == 'create' || mode == 'edit'
        ?
        <Cadastro item={itemEdit} />
        // <Formuario item={itemEdit} />
        :
        <Container sx={{ py: 3 }}>
          <Paper elevation={3} sx={{ p: 4}}>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Person sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                Gêneros Alimentícios
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            {success && (
              <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
                {success}
              </Alert>
            )}



            <form className='admin-form' onSubmit={handleSubmit(onSubmitBusca)}>
              {/* <div style={{display:'flex', flexDirection:'row'}}> */}
              <Grid container spacing={3}>
                {/* <div className="form-row col"> */}
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    // className='form-control'
                    className='col'
                    label="Nome do Alimento"
                    margin="normal"
                    {...register('nome', {
                      // required: 'Nome é obrigatório',
                      minLength: {
                        value: 3,
                        message: 'Nome deve ter no mínimo 3 caracteres'
                      }
                    })}
                    error={!!errors.nome}
                    helperText={errors.nome?.message}
                  />
                </Grid>
                
                <Grid item xs={12} md={4}>

                  <TextField
                    fullWidth
                    // className='form-control'
                    label="Medida"
                    margin="normal"
                    {...register('medida', {
                      // required: 'CAF é obrigatório'
                    })}
                    error={!!errors.medida}
                    helperText={errors.medida?.message}
                  />
                </Grid>
                
                <Grid item xs={12} md={12}>

                  {mode != 'create' ? (<Button
                    //   type="submit"
                    //   fullWidth
                    onClick={() => setMode('create')}
                    variant="contained"
                    size="large"
                    sx={{ mt: 3 }}
                    startIcon={<Save />}
                    disabled={loading}
                  >
                    {'Novo'}
                    {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                  </Button>) :

                    (<Button
                      // type="submit"
                      //   fullWidth
                      onClick={() => setMode('create')}
                      variant="contained"
                      size="large"
                      sx={{ mt: 3 }}
                      startIcon={<Save />}
                      disabled={loading}
                    >
                      {'Salvar'}
                      {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                    </Button>)
                  }

                  <Button
                    type="submit"
                    //   fullWidth
                    variant="contained"
                    size="large"
                    sx={{ mt: 3, marginLeft: 2, backgroundColor: '#ccdb00' }}
                    startIcon={mode == 'create' ? <KeyboardReturnIcon /> : <Search />}
                    disabled={loading}
                  >
                    {mode == 'create' ? 'Voltar' : 'Buscar'}
                    {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                  </Button>
                </Grid>
              </Grid>
            </form>

            {rows && mode !== 'create' && mode !== 'edit' && <React.Fragment>
              <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                  <TableHead>
                    <TableRow>
                      {/* <TableCell /> */}
                      <TableCell>Nome</TableCell>
                      <TableCell align="right">Medida</TableCell>                      
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => (
                        <Row key={row.name} row={row} />
                      ))}
                  </TableBody>
                  {/* <TableBody>
                    {rows.map((row) => (
                      <Row key={row.name} row={row} />
                    ))}
                  </TableBody> */}
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Linhas por página"
              />

            </React.Fragment>}

            
          </Paper>
        </Container>
      }
    </Box>
  )
}

export default Formalimento

